import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-documenttype',
  templateUrl: './documenttype.component.html',
  styleUrls: ['./documenttype.component.scss']
})
export class DocumentTypeComponent implements OnChanges {


  documenttypeForm: FormGroup;
  documenttypeFormArray: FormGroup;
  control = new FormControl();
  @Input() documenttypes: DocumentTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() documenttype = new EventEmitter<DocumentTypeDto[]>()
  @Output() deleteDocumentTypeEvent = new EventEmitter<any>()

    selectedDocumentType: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createDocumentTypeForm();
    }

    createDocumentTypeForm() {
      this.documenttypeForm = this.fb.group({
        DocumentTypeName: ['', Validators.required],
        id: null
        });
        this.documenttypeFormArray = this.fb.group({ DocumentTypes: this.fb.array([])
          });
        this.setDocumentType();
    }

  // method to display documenttypes
  setDocumentType() {
    const control  = this.documenttypeFormArray.controls.DocumentTypes as FormArray;
    this.documenttypes.forEach( e => {
      control.push(
        this.fb.group({
          DocumentTypeName: e.DocumentTypeName,
          id: e.id
        })
      );
    });
  }


  // method to add DocumentType
  addDocumentType(value: DocumentTypeDto) {
    const control  = this.documenttypeFormArray.controls.DocumentTypes as FormArray;
    control.insert(0,
          this.fb.group({
            DocumentTypeName: value.DocumentTypeName,
            id: null
          })
       );
  }

  selectDocumentType(value) {}

  // method to delete documenttype from arrary list
  deleteDocumentType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.documenttypeFormArray.controls.DocumentTypes as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.documenttypes.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.documenttypes[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: DocumentTypeDto) {
    if(this.documenttypeForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.documenttypeFormArray.get('DocumentTypes')['controls'][this.selectedIndex].patchValue({DocumentTypeName: formValue.DocumentTypeName});
    } else {
      this.addDocumentType(formValue);
    }
    this.selectedIndex = null;
    this.documenttypeForm.reset()
  }

  onEdit(index, value: DocumentTypeDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.documenttypeForm.patchValue({DocumentTypeName: value.DocumentTypeName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.documenttypeForm.reset();
  }

  onSubmit(formValue: DocumentTypeDto[]) {
  this.documenttype.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteDocumentTypeEvent.emit(this.filteredDelete);
  }
  }

}
